import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    .sazh-layout {
      grid-template-rows:
        var(--block-top-padding)
        minmax(0, auto)
        minmax(0, auto)
        minmax(0, auto)
        var(--block-bottom-padding)
        [last-line];
      max-width: 100%;
    }

    .header {
      grid-column: 2 / 8;
      grid-row: 2;
    }

    .text-section {
      grid-column: 2 / 8;
      grid-row: 3;
    }

    .downloads {
      grid-column: 2 / 8;
      grid-row: 4;
    }

    .column {
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      flex-grow: 1;
      gap: calc(30rem / var(--default-rem-px-count));
      min-width: calc(240rem / var(--default-rem-px-count));
      padding-bottom: calc(20rem / var(--default-rem-px-count));
      margin-bottom: calc(20rem / var(--default-rem-px-count));
    }

    .column-content {
      display: flex;
      flex-direction: column;
      gap: calc(14rem / var(--default-rem-px-count));
      width: 100%;
    }

    h4 {
      margin: 0;
      font-size: var(--fs-label-small);
      font-weight: var(--fw-medium);
      line-height: var(--lh-label-small);
      letter-spacing: var(--ls-label-small);
      text-transform: uppercase;
    }

    .row {
      width: 100%;
    }

    p {
      /* Some CMS entries have empty <p> tags that are supposed to act as
      line breaks. */
      min-height: 1em;
    }

    ul {
      margin-block-start: unset;
      margin-block-end: unset;
      /* Fixed indent — 1em would rescale the bullets with the type. */
      padding-inline-start: calc(21rem / var(--default-rem-px-count));

      li {
        margin-bottom: calc(8rem / var(--default-rem-px-count));
      }
    }

    @media (min-width: 600px) {
      .column {
        gap: calc(40rem / var(--default-rem-px-count));
      }

      ul {
        padding-inline-start: calc(24rem / var(--default-rem-px-count));

        li {
          margin-bottom: calc(16rem / var(--default-rem-px-count));
        }
      }

      .sazh-layout {
        grid-template-rows:
          var(--block-top-padding)
          minmax(0, auto)
          minmax(0, auto)
          var(--block-bottom-padding)
          [last-line];
        max-width: 100%;
      }

      /* Top-row texts share a first baseline. */
      .header {
        grid-column: 2 / 6;
        grid-row: 2 / 3;
        align-self: baseline;
      }

      .text-section {
        grid-column: 8 / 14;
        grid-row: 2;
        align-self: baseline;
      }

      .downloads {
        grid-column: 8 / 14;
        grid-row: 3;
      }
    }

    @media (min-width: 1024px) {
      .sazh-layout {
        grid-template-rows:
          var(--block-top-padding)
          minmax(0, auto)
          var(--block-bottom-padding)
          [last-line];
        max-width: 100%;
      }

      .header {
        grid-column: 2 / 5;
        grid-row: 2;
      }

      .text-section {
        grid-column: 8 / 11;
        grid-row: 2;
      }

      .downloads {
        grid-column: 11 / 14;
        grid-row: 2;
      }
    }
  `,
];
